import { useEffect, useState } from "react";

import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid2 } from "@mui/material";
import { useSnackbar } from "../Utility/UserMessageContext";
import NewPlan from "./NewPlan";
import PlanList from "./PlanList";
import PlanDetails from "./PlanDetails";
import PatientDetails from "../Patients/PatientDetails";

import AppointmentDetails from "../Appointments/AppointmentDetails";
import NewBill from "../Billing/NewBill";
import EditPatient from "../Patients/EditPatient";
import WorkItemDetails from "../Worklist/WorkItemDetails";
import EditPlan from "./EditPlan";

// import PlanTable1 from './PlanTable2';
// import './app1.css';

function PlanHome() {
  //  Load active tab from localStorage (or default to "Plans")
  const [PlanActiveTab, setPlanActiveTab] = useState(() => {
    const savedActiveTab = localStorage.getItem("PlanActiveTab");
    return savedActiveTab || "Plans"; // Default to "Enquiries" if no saved state
  }); // Current selected tab

  // const [tabs, setTabs] = React.useState([
  //   { label: 'Plans', value: "Plans" },
  //   // { label: '', value: 2 },
  //   // { label: 'Phone', value: 3 },
  // ]); // Fixed tabs: Home, Contact, and Phone
  const [tabs, setTabs] = React.useState(() => {
    // Load tabs from local storage
    const savedTabs = localStorage.getItem("plans-tabs");
    return savedTabs
      ? JSON.parse(savedTabs)
      : [{ label: "Plans", value: "Plans", type: "plan-list" }];
  });

  const [newPlans, setNewPlans] = useState([]);

  const [newPlanTabNumber, setNewPlanTabNumber] = useState(-1);
  const { showSnackbar } = useSnackbar();

  //const[newPrescriptionNumber, setNewPrescriptionNumber] = useState(-1);
  const [newPrescriptionTabNumber, setNewPrescriptionTabNumber] = useState(-1);

  useEffect(() => {
    // Save tabs to local storage whenever they change
    //var tabsToBeSaved = tabs.filter((t) => t.type !== "new-plan");
    localStorage.setItem("plans-tabs", JSON.stringify(tabs));
  }, [tabs]);

  useEffect(() => {
    localStorage.setItem("PlanActiveTab", PlanActiveTab);
  }, [PlanActiveTab]);

  const handleChange = (event, newValue) => {
    setPlanActiveTab(newValue);
  };

  const handleViewDetails = (planData) => {
    // Check if the tab is already open
    const existingTab = tabs.find((tab) => tab.value === planData.id);

    if (existingTab) {
      // If the tab exists, switch to it
      setPlanActiveTab(existingTab.value);
    } else {
      // Create a new tab if it doesn't exist
      const newTab = {
        label: planData?.displayId,
        value: planData?.id,
        type: "plan-details",
        props: JSON.stringify(planData),
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setPlanActiveTab(planData?.id); // Switch to the newly added tab
    }
  };

  const openNewPlanTab = (planType) => {
    // Check if the tab is already open
    var newTabNumber = 0;
    var newTabValue = "NewPlan" + newTabNumber;
    while (tabs.find((tab) => tab.value === newTabValue)) {
      newTabNumber++;
      newTabValue = "NewPlan" + newTabNumber;
    }

    setNewPlanTabNumber(newTabNumber);

    //const existingTab = tabs.find((tab) => tab.value === "NewPlan");

    // if (existingTab) {
    //   // If the tab exists, switch to it
    //   setValue(existingTab.value);
    // } else {
    //Create a new tab if it doesn't exist
    //const newTabValue = tabs.length + 1; // Assign a unique value for the new tab
    const newTab = {
      label: newTabNumber === 0 ? `New Plan` : `New Plan (${newTabNumber})`,
      value: "NewPlan" + newTabNumber,
      type: "new-plan",
      props: { planType: String(planType) }, // perform type casting to string without this getting error ,we have   review it once  by asim sir
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab("NewPlan" + newTabNumber); // Switch to the newly added tab
  };

  // const handleViewPatientDetails = (patientData) => {
  //   const existingTab = tabs.find(
  //     (tab) => tab.value === `PatientDetails-${patientData.id}`
  //   );
  //   if (existingTab) {
  //     setValue(existingTab.value);
  //     return;
  //   }

  //   const newTab = {
  //     label: `${patientData.firstName} ${patientData.lastName}`,
  //     value: `PatientDetails-${patientData.id}`,
  //     type: "patient-details",
  //     patientData: patientData,
  //   };

  //   setTabs((prevTabs) => [...prevTabs, newTab]);
  //   setValue(newTab.value);
  // };

  const handleEditPlan = (plan) => {
    const existingTab = tabs.find((tab) => tab.value === `EditPlan${plan.id}`);
    if (existingTab) {
      setPlanActiveTab(existingTab.value);
      return;
    }
    const newTab = {
      label: `Edit - ${plan?.displayId}`,
      value: "EditPlan" + plan?.id,
      plan: plan,
      type: "edit-plan",
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab(newTab.value); // Switch to the newly added tab
  };

  const handleViewPatientDetails = (patientData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `PatientDetails-${patientData.id}`
    );
    if (existingTab) {
      setPlanActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `${patientData.firstName} ${patientData.lastName}`,
      value: `PatientDetails-${patientData.id}`,
      type: "patient-details",
      patientData: patientData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab(newTab.value);
  };

  const handleViewVisitDetails = (visitData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `VisitDetails-${visitData.id}`
    );
    if (existingTab) {
      setPlanActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: visitData?.displayId,
      value: `VisitDetails-${visitData.id}`,
      type: "visit-details",
      visitData: visitData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab(newTab.value);
  };

  const openBillTab = (billData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `EditBill-${billData.id}`
    );
    if (existingTab) {
      setPlanActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `Edit Bill - ${billData.patientName}`,
      value: `EditBill-${billData.id}`,
      type: "edit-bill",
      billData: billData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab(newTab.value);
  };

  const handleViewWorklistDetails = (worklistData) => {
    const existingTab = tabs.find(
      (tab) => tab.value === `WorklistDetails-${worklistData.id}`
    );
    if (existingTab) {
      setPlanActiveTab(existingTab.value);
      return;
    }

    const newTab = {
      label: `Worklist - ${worklistData.displayId}`,
      value: `WorklistDetails-${worklistData.id}`,
      type: "worklist-details",
      worklistData: worklistData,
    };

    setTabs((prevTabs) => [...prevTabs, newTab]);
    setPlanActiveTab(newTab.value);
  };
  const handleEditPatientTab = (patient) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find(
        (tab) => tab.value === `EditPatient-${patient.id}`
      );

      if (existingTab) {
        setPlanActiveTab(existingTab.value);
        return prevTabs;
      }

      const newTab = {
        label: `Edit ${patient.firstName} ${patient.lastName}`,
        value: `EditPatient-${patient.id}`,
        type: "EditPatient",
        patient: patient,
        //content: <EditPatient patient={patient} onSave={handleSaveEdit} />,
      };

      setPlanActiveTab(newTab.value);
      return [...prevTabs, newTab];
    });
  };
  const handleSaveEdit = (updatedPatient) => {
    // Close the edit tab
    const updatedTabs = tabs.filter(
      (tab) => !tab.value.startsWith("EditPatient")
    );
    setTabs(updatedTabs);

    // Switch back to the patient details tab
    const patientDetailsTab = tabs.find(
      (tab) => tab.value === `patient-${updatedPatient.id}`
    );
    if (patientDetailsTab) {
      setPlanActiveTab(patientDetailsTab.value);
    } else {
      setPlanActiveTab("Patients");
    }
  };

  const openPrescriptionViewTab = (
    prescriptionId,
    prescriptionDisplayId,
    prescriptionType
  ) => {
    setTabs((prevTabs) => {
      const existingTab = tabs.find((tab) => tab.value === prescriptionId);
      if (existingTab) {
        setPlanActiveTab(existingTab.value);
      } else {
        const newTab = {
          label: prescriptionDisplayId || "Prescription",
          value: prescriptionId,
          type: "ViewPrescription",
          prescriptionId: prescriptionId,
          prescriptionType: prescriptionType,
        };

        setPlanActiveTab(prescriptionId);
        return [...prevTabs, newTab];
      }
      return prevTabs;
    });
  };

  const handleCloseTab = (tabValue) => {
    // Prevent closing fixed tabs
    if (tabValue === "Plans") return;

    const remainingTabs = tabs.filter((tab) => tab.value !== tabValue);

    setTabs(remainingTabs);
    setPlanActiveTab(remainingTabs[remainingTabs.length - 1].value); // Switch to the last tab
    localStorage.removeItem(tabValue);
  };

  return (
    <Grid2 container>
      <TabContext value={PlanActiveTab}>
        <Grid2
          container
          size={12}
          alignItems="center"
          spacing={1}
          sx={{ borderBottom: "1px solid lightgray", width: "100%" }}
        >
          <Tabs
            value={PlanActiveTab}
            onChange={handleChange}
            variant="scrollable"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={
                  <Box>
                    {tab.label}
                    {tab.value !== "Plans" && ( // Show close button only for dynamic tabs
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering tab change
                          handleCloseTab(tab.value);
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                }
                value={tab.value}
              />
            ))}
          </Tabs>
        </Grid2>

        {tabs.map((tab) => (
          <TabPanel
            key={tab.value}
            value={tab.value}
            sx={{ padding: "0px", width: "100%" }}
            keepMounted={tab.value !== "Plans"}
          >
            {tab.type === "plan-list" && (
              <PlanList
                onViewDetails={handleViewDetails}
                onAddNewPlan={openNewPlanTab}
                onEditPlan={handleEditPlan}
                  onViewPatientDetails={handleViewPatientDetails}
              />
            )}
            {tab.type === "new-plan" && (
              <NewPlan
                key={tab?.value}
                newPlanTempId={tab?.value}
                planType={tab?.props?.planType}
                closeTab={handleCloseTab}
              />
            )}
            {/* {tab.value !== "Plans" && tab.content} */}
            {tab.type === "plan-details" && (
              <PlanDetails
                key={tab?.value}
                selectedPlan={tab?.props && JSON.parse(tab?.props)}
                onViewPatientDetails={handleViewPatientDetails}
                onViewVisitDetails={handleViewVisitDetails}
                onEditBill={openBillTab}
                onEditPlan={handleEditPlan}

              />
            )}

            {/* edit plan  */}
            {tab.type === "edit-plan" && (
              <EditPlan
                key={tab?.value}
                planId={tab?.plan?.id}
                plan={tab?.plan}
                onViewPatientDetails={handleViewPatientDetails}
                onViewVisitDetails={handleViewVisitDetails}
                onEditBill={openBillTab}
                closeTab={handleCloseTab}
              />
            )}

            {tab.type === "patient-details" && (
              <PatientDetails
                key={tab?.value}
                patientId={tab?.patientData?.id}
                onOpenTab={handleEditPatientTab}
                onViewDocument={openPrescriptionViewTab}
                closeTab={handleCloseTab}
              />
            )}
            {tab.type === "EditPatient" && (
              <EditPatient patient={tab.patient} onSave={handleSaveEdit} />
            )}
            {tab.type === "visit-details" && (
              <AppointmentDetails
                key={tab?.value}
                selectedVisitId={tab?.visitData?.id}
                selectedAppointment={tab?.props && JSON.parse(tab?.props)}
                onEditBill={openBillTab}
                onViewPatientDetails={handleViewPatientDetails}
                onViewWorklistDetails={handleViewWorklistDetails}
              />
            )}
            {tab.type === "worklist-details" && (
              <WorkItemDetails
                key={tab?.value}
                serviceId={tab?.worklistData?.id}
                onViewPatientDetails={handleViewPatientDetails}
                onViewVisitDetails={handleViewVisitDetails}
                closeTab={handleCloseTab}
              />
            )}
            {tab.type === "edit-bill" && (
              <NewBill
                key={tab?.value}
                billId={tab?.billData?.id}
                closeTab={handleCloseTab}
              />
            )}
            {/* {tab.type === "edit-plan" && <EditPlan key={tab?.value} plan={tab?.plan} closeTab={handleCloseTab} />} */}
            {tab.type === "patient-details" && (
              <PatientDetails
                key={tab?.value}
                patientId={tab?.patientData?.id}
                closeTab={handleCloseTab}
              />
            )}
          </TabPanel>
        ))}
      </TabContext>
    </Grid2>
  );
}

export default PlanHome;
